import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";

export const updateAssetSerialNumbersTodo = createAsyncThunk("updateAssetSerialNumbers", async ({ serial_numbers, navigate }) => {
    try {
        const res = await axios({
            method: "PUT",
            url: process.env.REACT_APP_API_URL + "asset_details_serial_numbers",
            data: {
                serial_numbers,
            },
            headers: {
                "Content-Type": "application/json",
                Authorization: SessionManager.getSession("user_token"),
            },
        });
        return res;
    } catch (error) {
        return error.response;
    }
}
);

const updateAssetSerialNumbersSlice = createSlice({
    name: "updateAssetSerialNumbers",
    initialState: {
        loading: false,
        response: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(updateAssetSerialNumbersTodo.pending, (state) => {
            state.loading = true;
            state.response = null;
        });
        builder.addCase(updateAssetSerialNumbersTodo.fulfilled, (state, action) => {
            state.loading = false;
            if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate);
            }
            state.response = action.payload;
        });
        builder.addCase(updateAssetSerialNumbersTodo.rejected, (state) => {
            state.loading = false;
        });
    },
});

export default updateAssetSerialNumbersSlice.reducer;

